import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-17646 — every name a person or a booking type has had in a booking link. The row
 * with `isCurrent` set is the name in use; a retired row keeps the old link redirecting
 * and keeps the name from being taken by someone else, so rows are never removed.
 *
 * `scopeKey` is what a name must be unique within: `person` for the tenant's people,
 * `type:<userId>` for one person's booking types (see bookingNameScopeKey).
 */
@Index('IDX_booking_name_scope_name', ['scopeKey', 'name'], { unique: true })
@Index('IDX_booking_name_user', ['fkUserId'])
@Index('IDX_booking_name_type', ['fkBookingTypeId'])
@Entity('booking_name')
export class BookingNameEntity extends BaseEntity {
	@Column('varchar', { name: 'scopeKey', length: 32 })
	public scopeKey!: string;

	/** Always lowercase; the column's collation makes the unique index case-insensitive too. */
	@Column('varchar', { name: 'name', length: 40 })
	public name!: string;

	/** The person this name belongs to, or the host of the booking type. */
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	/** Null for a person's name. */
	@Column('int', { name: 'fk_booking_type__id', unsigned: true, nullable: true })
	public fkBookingTypeId!: number | null;

	@Column({ type: 'boolean', name: 'isCurrent', width: 1, default: () => "'1'" })
	public isCurrent!: boolean;
}

export const BOOKING_NAME_PERSON_SCOPE = 'person';

export function bookingNameScopeKey(userIdForType: number | null): string {
	return userIdForType == null ? BOOKING_NAME_PERSON_SCOPE : `type:${String(userIdForType)}`;
}
